/* eslint-disable */
import React, { Component } from 'react';
import {Button, Icon} from"semantic-ui-react"; 
import KnowledgeBase from './knowledge_base';
import { getKnowledgeBaseData } from '../../data/dashboard_api';
import moment from 'moment';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOffline: false,
            backOnline: false,
            showKnowledgeBase:false,
            checkKnowledgeBase:false,
            detailsSaved:true
        };
    }

    componentWillMount() {
        window.addEventListener('online', () => this.updateIndicator(true));
        window.addEventListener('offline', () => this.updateIndicator(false));
        this.updateIndicator(true);
    }

    componentDidMount() {
        this.checkDarkMode();
        if(localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role == "clerk"){
            getKnowledgeBaseData(true).then((response) =>{
                if (response.success){
                    if (response.articles && response.articles.length && response.articles[response.articles.length - 1] ) {
                        let dateCheck = undefined
                        let details_saved = response.articles[response.articles.length - 1].details_saved
                        if(response.articles[response.articles.length - 1].last_checked) {
                        dateCheck = moment(response.articles[response.articles.length - 1].created_at).isAfter( moment(response.articles[response.articles.length - 1].last_checked))
                    }
                        else {
                            dateCheck = true
                        }
                        
                    this.setState({checkKnowledgeBase:dateCheck,detailsSaved:details_saved})
                    }
                }
            })
        }   
    }

    updateIndicator = (isOnline) => {
        this.setState({showOffline: !isOnline});
    };

    toggleDarkMode = () => {
        if (JSON.parse(localStorage.getItem("dark"))) { localStorage.setItem("dark", false); document.body.classList.remove("dark"); }
        else {
            localStorage.setItem("dark", true); document.body.classList.add("dark");
        }
    }

    checkDarkMode = () => {
        JSON.parse(localStorage.getItem("dark"))? document.body.classList.add("dark") : null}

    render() {
        return (
            <div  style={{position:"relative",zIndex:1000}}>
                {this.state.showOffline && <div className='ui icon negative message offline-banner'>
                <i aria-hidden='true' className='circle notched loading icon'/>
                <div className='content'>
                    <div className='header'>Currently Offline</div>
                    <p>No Internet connection. Please proceed with caution.<br/>
                        1. Do not save changes until connection is back.<br/>
                        2. Add Alarms, keys, meters, receipts after the connection is back to avoid data loss.<br/>
                        3. Do not Refresh page if you need to keep data entered so far.<br/>
                    </p>
                </div>
            </div>}
            {this.state.showKnowledgeBase && <KnowledgeBase handleClose={()=>{this.setState({showKnowledgeBase:false})}} userRole={JSON.parse(localStorage.getItem("user")).role} showKnowledgeBase={this.state.showKnowledgeBase}/>}
            <span id="versionIndicator">
            {localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role !== "agent" && <Button circular icon color={this.state.checkKnowledgeBase? "red":undefined}  size={this.state.checkKnowledgeBase ? "massive":""} onClick={()=>{this.setState({showKnowledgeBase:true,checkKnowledgeBase:false})}}><Icon name="question"></Icon>{this.state.checkKnowledgeBase? "New Articles Posted":""}</Button>}
            {localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role == "clerk" && !this.state.detailsSaved && <Button circular>Please update availability info in Clerk Profile page</Button>}
            <Button compact onClick={() => this.toggleDarkMode()}>Dark mode</Button> v1.6</span>
            </div>
        );
    }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/views/universal/footer.js